var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.93917 3.02619L3.15377 3.02619L3.15377 1.67847L10.3234 1.67847L10.3234 3.02619L10.3124 3.02619L10.3124 8.91559L8.96465 8.91559L8.96464 4.07232L2.71549 10.3215L1.67969 9.28567L7.93917 3.02619Z",
    fill: "#FF6231"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferOut);
export default __webpack_public_path__ + "static/media/transfer-out.9b3fb37adf59aa5ad88639640924c8b2.svg";
export { ForwardRef as ReactComponent };